'use client';

import './index.css';

// Atomic Components
export * from './atomics';

// Composite Components
export * from './composites';

// Component Catalog types (EDU Component Schema v1)
export * from './catalog';

// Portal container context — used by consumers with scoped CSS (e.g. dynamic-experiences)
export {
  PortalContainerProvider,
  usePortalContainer,
} from './providers/PortalContainerContext';

export type { InlinePhrasingTag } from './lib/inline-copy';
export {
  INLINE_PHRASING_TAG_LIST,
  INLINE_PHRASING_TAGS,
  isSafeInlineLinkHref,
} from './lib/inline-copy';

// Host-injected tenant glyph pack — UI-only; hosts GET tenant-config `icons` and wrap
export { IconRegistry, useIconRegistry } from './providers/IconRegistry';
export type {
  IconColorMode,
  IconRegistryEntry,
  IconRegistryMap,
} from './providers/IconRegistry';
